
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27 3.781V21c0 2.197-1.803 4-4 4s-4-1.803-4-4 1.803-4 4-4a3.92 3.92 0 012 .563v-7.375l-14 2.625v11.188c0 2.197-1.803 4-4 4s-4-1.803-4-4 1.803-4 4-4a3.92 3.92 0 012 .563V7.158l.813-.125 16-3zm-2 2.407L11 8.813v2l14-2.625v-2zM23 19c-1.116 0-2 .884-2 2s.884 2 2 2 2-.884 2-2-.884-2-2-2zM7 22c-1.116 0-2 .884-2 2s.884 2 2 2 2-.884 2-2-.884-2-2-2z"}})])
          )
        }
      }
    